import { loadMarketSymbols, loadMarketKlines } from './market_proxy_client';
import { createExchangeWs } from './exchange_ws_base';

export default {
    symbols: [],

    async loadExchangeInfo() {
        this.symbols = await loadMarketSymbols('bybit');
        return this.symbols;
    },
    async loadKline(symbol, tf, endTime) {
        return loadMarketKlines('bybit', symbol, tf, endTime);
    },

    ...createExchangeWs({
        wsUrl: 'wss://stream.bybit.com/v5/public/spot',
        buildSubscribe: symbols => JSON.stringify({ op: 'subscribe', args: symbols.map(s => 'tickers.' + s) }),
        buildUnsubscribe: symbols => JSON.stringify({ op: 'unsubscribe', args: symbols.map(s => 'tickers.' + s) }),
        pingMessage: JSON.stringify({ op: 'ping' }),
    }),
};
